import React, { useContext } from "react"
import { useInView } from "react-intersection-observer"
import AutoSizer from "react-virtualized-auto-sizer"
import HeroWrapper from "../HeroWrapper"
import { ThemeContext } from "../layout"
import Timeline from "../Timeline"
import SkillsChart from "../SkillsChart"

function SkillsExperience(props) {
  const theme = useContext(ThemeContext)
  const [ref, inView] = useInView({
    threshold: 0.5,
    triggerOnce: true,
  })
  return (
    <HeroWrapper id="skills" theme={theme}>
      <div className="hero-body">
        <div className="container">
          <h1 className="title is-2">Experience and Skills</h1>
          <div
            className="columns is-fluid is-flex"
            style={{ flexDirection: "column" }}
          >
            <div className="column">
              <div className="columns">
                <div className="column">
                  <Timeline />
                </div>
                <div ref={ref} className="column">
                  <div className="chart-container">
                    <AutoSizer>
                      {({ width, height }) => {
                        return !width || !height || !inView ? null : (
                          <SkillsChart
                            width={width}
                            height={height}
                            theme={theme}
                          />
                        )
                      }}
                    </AutoSizer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </HeroWrapper>
  )
}

export default SkillsExperience
